import { CheckCircle2 } from "lucide-react";

/**
 * Property attributes/features list
 */
export function DetailAttributes({ attributes, isDark, maxItems = 12 }) {
  if (!attributes || attributes.length === 0) return null;

  return (
    <div>
      <div className={`text-xs font-semibold mb-2 ${isDark ? "text-white/60" : "text-gray-500"}`}>
        Özellikler
      </div>
      <div className="flex flex-wrap gap-1.5">
        {attributes.slice(0, maxItems).map((attr, idx) => (
          <span
            key={idx}
            className={`inline-flex items-center gap-1 text-xs px-2 py-1 rounded-lg ${
              isDark ? "bg-white/10 text-white/70" : "bg-gray-100 text-gray-600"
            }`}
          >
            <CheckCircle2 className="h-3 w-3" strokeWidth={1.5} />
            {attr}
          </span>
        ))}
        {attributes.length > maxItems && (
          <span className={`text-xs px-2 py-1 ${isDark ? "text-white/40" : "text-gray-400"}`}>
            +{attributes.length - maxItems} daha
          </span>
        )}
      </div>
    </div>
  );
}

export default DetailAttributes;
